












































































import Vue from 'vue'
import Component from 'vue-class-component'
import { ElInput } from 'element-ui/types/input'
import { mapGetters, mapState, mapActions } from 'vuex'
import { dropbox } from '../api/dropbox'
import { Param } from '../interfaces/product'
import { ElMenu } from 'element-ui/types/menu'

const BaseVue = Vue.extend({
  computed: {
    ...mapState(['rawTotalPages', 'params']),
    ...mapGetters(['cartQuantity', 'currentPage', 'inMobilePages'])
  },
  methods: {
    ...mapActions(['setCurrentPageIndexFromPage'])
  }
})

@Component
export default class Navbar extends BaseVue {
  enteredPage = null
  shownInputPage = false

  get currentPageText () {
    return this.inMobilePages || this.currentPage === 1 || this.currentPage === this.rawTotalPages - 2
      ? this.currentPage
      : `${this.currentPage} - ${this.currentPage + 1}`
  }

  onIndexChange () {
    const page = parseInt(this.enteredPage as any)

    if (!Number.isNaN(page)) {
      this.setCurrentPageIndexFromPage(page)
    }

    const inputPageRef = this.$refs.inputPageRef as ElInput
    inputPageRef.blur()
  }

  onShowCart () {
    this.$emit('onShowCart')
  }

  onShowSections () {
    this.$emit('onShowSections')
    this.hideMobileMenu()
  }

  async showInputPage () {
    this.shownInputPage = true

    await this.$nextTick()

    const inputPageRef = this.$refs.inputPageRef as ElInput
    inputPageRef.focus()
  }

  hideInputPage () {
    this.enteredPage = null
    this.shownInputPage = false
  }

  hideMobileMenu () {
    setTimeout(() => {
      (this.$refs.menu as ElMenu).close('mobile-menu')
    }, 100)
  }

  async downloadCatalog () {
    const { DESCRIPCION } = this.params.find((param: Param) => param.PARAMETRO === 'CATALOGO_EN_PDF')
    const { url } = await dropbox.sharingCreateSharedLink({ path: `/${DESCRIPCION}` })

    // Download
    const anchor = document.createElement('a')

    anchor.download = DESCRIPCION
    anchor.href = url.replace(/0$/, '1')

    anchor.click()
  }

  shareCurrentPage () {
    const { DESCRIPCION } = this.params.find((param: Param) => param.PARAMETRO === 'MENSAJE_COMPARTIR')

    ;(navigator as any).share({
      title: 'Catálogo Web',
      text: DESCRIPCION.replace('{URL}', location.origin),
      url: ''
    })
  }
}
